import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=6c960007&scoped=true"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"
import style0 from "./RichText.vue?vue&type=style&index=0&id=6c960007&prod&lang=less&scoped=true"
import style1 from "./RichText.vue?vue&type=style&index=1&id=6c960007&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c960007",
  null
  
)

export default component.exports